/** A consistent, decorative format marker for the library and format picker. */
export function FormatGlyph({ format }: { format: string }) {
  return (
    <span className={`format-glyph format-glyph-${format}`} aria-hidden="true">
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {format === 'poll' ? (
          <>
            <path d="M5 19V11M12 19V5M19 19V8" />
            <path d="M3 21h18" />
          </>
        ) : format === 'trivia_quiz' ? (
          <>
            <path d="M9 8a3 3 0 0 1 6 0c0 2-3 2-3 5M12 17v.1" />
            <circle cx="12" cy="12" r="10" />
          </>
        ) : format === 'personality_quiz' ? (
          <>
            <path d="m12 3 3 6 6 3-6 3-3 6-3-6-6-3 6-3Z" />
          </>
        ) : format === 'survey' ? (
          <>
            <path d="M10 6h10M10 12h10M10 18h10M3 6l1 1 2-2M3 12l1 1 2-2M3 18l1 1 2-2" />
          </>
        ) : (
          <>
            <rect x="4" y="3" width="16" height="18" rx="2" />
            <path d="M8 8h8M8 12h8M8 16h4" />
          </>
        )}
      </svg>
    </span>
  );
}
